export var ourSolutionsInfo = {
    fmPro: {
        brochureUrl: "/media/Brochures2025/FMPro.25.1.pdf",
        videoUrl: "https://youtu.be/DKHa92e6ECg",
    }
}